import { useApiClient } from '../client'
import { invopopSupplierRegistrationPath } from '../invopop-adapter/consts.ts'
import { invopopAdapterHeaders, resolveInvopopAdapterUrl } from '../invopop-adapter/resolve-url'
import type { InvopopRegistrationResponse } from '../invopop-adapter/types.ts'

export function getInvopopRegistration (businessId: number | string) {
  const apiClient = useApiClient()

  return apiClient.get<InvopopRegistrationResponse>({
    url: resolveInvopopAdapterUrl(invopopSupplierRegistrationPath(businessId)),
    headers: invopopAdapterHeaders(),
  })
}
